class notificationBar extends HTMLElement {
  constructor() {
    super();
    this.close = this.querySelector('.icon-cross');
    let closeStatus = sessionStorage.getItem("notificationBar");

    this.showBar()

    if (closeStatus == 'closed') {
      this.closeBar()
    }

    this.addEventListener('click', (event) => {
      if (event.target === this.close) {
        this.closeBar()
      }
    })
  }

  closeBar () {
    this.classList.add('hidden')
    sessionStorage.setItem("notificationBar", "closed");
  }

  showBar() {
    this.classList.remove('hidden')
    sessionStorage.removeItem("notificationBar");
  }

}

customElements.define('notification-bar', notificationBar);
